import { render, staticRenderFns } from "./vinsTimeLineComposent.vue?vue&type=template&id=d87042b6&scoped=true&"
import script from "./vinsTimeLineComposent.vue?vue&type=script&lang=js&"
export * from "./vinsTimeLineComposent.vue?vue&type=script&lang=js&"
import style0 from "./vinsTimeLineComposent.vue?vue&type=style&index=0&id=d87042b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87042b6",
  null
  
)

export default component.exports